// components/DesktopCart.jsx - Functional Desktop Layout
import React from 'react';
import ProductDisplay from './ProductDisplay';
import OrderSummary from './OrderSummary';

const DesktopCart = ({ displayProducts, user, gold, translate, deleteFromCart, deleteThisProductId, cart_items, cart_credit }) => {
  return (
    <div className='marketplace-desktop-layout'>
      {Object.keys(user).length > 0 && (
        <div className='marketplace-info-sidebar'>
          <div className='marketplace-sidebar-panel'>
            <OrderSummary user={user} translate={translate} cart_items={cart_items} cart_credit={cart_credit} />
          </div>
        </div>
      )}

      <div className='marketplace-cart-column'>
        <div className='marketplace-cart-panel'>
          <div className='marketplace-cart-title'>سبد خرید شما</div>
          <ProductDisplay displayProducts={displayProducts} user={user} gold={gold} translate={translate} onDelete={deleteFromCart} deleteThisProductId={deleteThisProductId} />
        </div>
      </div>
    </div>
  );
};

export default DesktopCart;
